/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>

(function($, _) {
  var ns;

  ns = window.nspace("ccc.profileSelection");

  /**
   * Renders the display of the indicator checkboxes.
   */
  ns.IndicatorSelectionCheckboxView = Backbone.View.extend({
    initialize: function() {
      _.bindAll(this);

      this.model.once("change", this.render);
      this.model.on("change:locationType change:indicators", this.render);
    },

    events: {
      "click .subtopic-list input": "toggleIndicator"
    },

    /**
     * Set's the model's indicator property in response to DOM events.
     */
    toggleIndicator: function(e) {
      var $input, $self, indicatorId, indicators;

      $input = $(e.currentTarget);
      $self = $input.parents("li:first");
      indicatorId = +$self.data("indicator-id");

      indicators = indicatorId
        ? this.getSingleIndicator(indicatorId)
        : this.getMultipleIndicators($self, $input);

      this.model.set("indicators", indicators);

      // Tracks clicks on an indicator or subindicator checkbox (Ex: Total Population) on the "Create Location Profiles" page
      if (indicators && indicators.length) {
        if (indicatorId && !$("input[type=checkbox]", $self)[0].checked) {
          return; // Indicator was de-selected
        }

        // Get the names of the selected indicators
        // Remove excess whitespace, and separate indicators with a pipe
        var regex = /[\t\r\n]+/gi;
        var rawText = $self.text().trim();
        var temp = rawText.replace(regex, "|").split("|");
        if (temp.length > 1) {
          // Remove duplicated root indicator name
          temp.splice(0, 1);
        }
        var formattedIndicators = temp.join("|");
        dataLayer.push({
          event: "LP Indicator Selection",
          eventCategory: "Interactive Clicks",
          eventAction: "Indicator Selection|" + formattedIndicators,
          eventLabel: window.location.pathname
        });
      }
    },

    /**
     * Toggles the children of the checked indicator group from the model's indicator collection.
     */
    getMultipleIndicators: function($el, $input) {
      var indicators, childIndicators;

      indicators = _.clone(this.model.get("indicators"));
      childIndicators = $el
        .find(".child li")
        .map(function() {
          return +$(this).data("indicator-id");
        })
        .get();

      if ($input.prop("checked")) {
        indicators = _.union(indicators, childIndicators);
      }
      else {
        indicators = _.reject(indicators, function(indicator) {
          return _.any(childIndicators, function(childIndicator) {
            return childIndicator === +indicator;
          });
        });
      }

      return indicators;
    },

    /**
     * Toggles the checked indicator from the model's indicator collection.
     */
    getSingleIndicator: function(indicatorId, shouldKeepIndicatorInCollection) {
      var indicators, indicatorInCollection;

      indicators = _.clone(this.model.get("indicators"));

      indicatorInCollection = _.any(indicators, function(indicator) {
        return +indicator === indicatorId;
      });

      if (indicatorInCollection) {
        if (shouldKeepIndicatorInCollection) {
          return indicators;
        }
        indicators = _.reject(indicators, function(indicator) {
          return +indicator === indicatorId;
        });
      }
      else {
        indicators.push(indicatorId);
      }

      return indicators;
    },

    /**
     * Makes the child indicator ul expand on initial click. Per Teresa, these uls expand once on initial click, then stay expanded no matter what.
     */
    expandChildIndicators: function() {
      var self;

      self = this;
      _.each(this.model.get("indicators"), function(indicator) {
        var $ul;

        $ul = self
          .$("li[data-indicator-id=" + indicator + "]")
          .parent(".child");

        if (!$ul.length) {
          // This is a loose indicator, so need to slide anything down.
          return;
        }

        if ($ul.css("display") === "block") {
          // slideDown sets the display to block, so if we're there already, no need to repeat.
          return;
        }

        $ul.slideDown(700);
      });
    },

    /**
     * Checks the indicator boxes in response to changes to the model's indicator property.
     */
    checkIndicators: function() {
      var indicators;

      // Making our indicator array to an object for faster lookup.
      indicators = _.object(
        _.map(this.model.get("indicators"), function(indicator) {
          return [indicator, true];
        })
      );

      this.$("li[data-indicator-id]").each(function() {
        var $self, $input;

        $self = $(this);
        $input = $self.find("input");
        if (indicators[$self.data("indicator-id")]) {
          $input.prop("checked", true);
          return;
        }
        $input.prop("checked", false);
      });
    },

    /**
     * Makes sure the indicator group checkbox matches the state of the checked indicators in the model.
     */
    checkIndicatorGroups: function() {
      this.$("ul.subtopic-list.child").each(function() {
        var $self, $inputs, indicatorCount, checkedIndicatorCount;

        $self = $(this);
        $inputs = $self.find("li input:checkbox");
        indicatorCount = $inputs.length;
        checkedIndicatorCount = $inputs.filter(":checked").length;

        $self
          .prev()
          .children("input")
          .prop("checked", indicatorCount === checkedIndicatorCount);
      });
    },

    /**
     * Makes the indicator checkboxes disabled if they aren't valid for the currently selected location.
     */
    toggleIndicatorDisabledStatus: function() {
      var locationType;

      locationType = +this.model.get("locationType");

      if (!locationType) {
        return;
      }

      this.$("li[data-loctype-ids][data-indicator-id]").each(function() {
        var $self,
          locTypeIdsRaw,
          areLocTypeIdsMultiple,
          locTypeIds,
          shouldBeEnabled;

        $self = $(this);

        locTypeIdsRaw = $self.data("loctype-ids");
        // We may get into a situation where we only have one location type defined for a category/indicator.
        // In this case, if there's only one location, .data will return an int, which doesn't have a split
        // function. So checking for the existing of that function will tells us to either split the location
        // type id or wrap it in an array.
        areLocTypeIdsMultiple = !!locTypeIdsRaw.split;
        locTypeIds = areLocTypeIdsMultiple
          ? locTypeIdsRaw.split(",")
          : [locTypeIdsRaw];

        shouldBeEnabled = _.any(locTypeIds, function(locTypeId) {
          return +locTypeId === locationType;
        });

        if (shouldBeEnabled) {
          $self.prop("title", "");
          $self.find("input").prop("disabled", false);
          $self.find("label").removeClass("disabled");
          return;
        }

        $self.prop("title", "Not available for the selected location");
        $self.find("input").prop("disabled", true);
        $self.find("label").addClass("disabled");
      });
    },

    /**
     * A parent render method.
     */
    render: function() {
      this.expandChildIndicators();
      this.toggleIndicatorDisabledStatus();
      this.checkIndicators();
      this.checkIndicatorGroups();
    }
  });
})(jQuery, _);
